module.exports = __webpack_public_path__ + "8a561f66b423813804b66621ef24ac93.woff2";